<div [class]="positionClasses">
  <span></span>
  <span></span>
  <span></span>
  <span></span>
</div>
